"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadElementsFromStaticElements = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var sdk_model_1 = require("@gooddata/sdk-model");
var flow_1 = tslib_1.__importDefault(require("lodash/flow"));
var InMemoryPaging_1 = require("./InMemoryPaging");
var resolveHiddenElements = function (hiddenElements) {
    return function (staticElements) {
        if (sdk_model_1.attributeElementsIsEmpty(hiddenElements)) {
            return staticElements;
        }
        return sdk_model_1.isAttributeElementsByRef(hiddenElements)
            ? staticElements.filter(function (item) { return !hiddenElements.uris.includes(item.uri); })
            : staticElements.filter(function (item) { return !hiddenElements.values.includes(item.title); });
    };
};
var resolveSelectedElements = function (selectedElements) {
    return function (staticElements) {
        if (!selectedElements) {
            return staticElements;
        }
        if (sdk_backend_spi_1.isElementsQueryOptionsElementsByPrimaryDisplayFormValue(selectedElements)) {
            throw new sdk_backend_spi_1.NotImplemented("Elements by primary display form value are not supported yet");
        }
        return sdk_backend_spi_1.isElementsQueryOptionsElementsByValue(selectedElements)
            ? staticElements.filter(function (element) { return selectedElements.values.includes(element.title); })
            : staticElements.filter(function (element) { return selectedElements.uris.includes(element.uri); });
    };
};
var resolveStringFilter = function (filter) {
    return function (staticElements) {
        return filter
            ? staticElements.filter(function (item) { return item.title.toLowerCase().includes(filter.toLowerCase()); })
            : staticElements;
    };
};
/**
 * @internal
 */
function loadElementsFromStaticElements(options, hiddenElementsInfo, staticElements) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var resolvedElements;
        return tslib_1.__generator(this, function (_a) {
            resolvedElements = flow_1.default(resolveHiddenElements(hiddenElementsInfo.hiddenElements), resolveSelectedElements(options.elements), resolveStringFilter(options.search))(staticElements);
            if (options.order === "desc") {
                resolvedElements = tslib_1.__spreadArrays(resolvedElements).reverse();
            }
            return [2 /*return*/, new InMemoryPaging_1.InMemoryPaging(resolvedElements, options.limit, options.offset)];
        });
    });
}
exports.loadElementsFromStaticElements = loadElementsFromStaticElements;
//# sourceMappingURL=loadElementsFromStaticElements.js.map